import { useEffect } from "react";

export function useOAuthCallbackRelay(): void {
    useEffect(() => {
        const opener = window.opener as Window | null;
        if (!opener || opener.closed) return;

        const search = window.location.search;
        if (!search || search === "?") return;

        const params: Record<string, string> = {};
        new URLSearchParams(search).forEach((value, key) => {
            params[key] = value;
        });

        if (Object.keys(params).length === 0) return;

        opener.postMessage(
            { type: "oauth-callback", params },
            window.location.origin,
        );

        const timer = setTimeout(() => window.close(), 100);
        return () => clearTimeout(timer);
    }, []);
}
